import styled from '@emotion/styled'

export const ArticleWrapper = styled.div`
  width: 100%;
`
